export enum MediaLibraryPath {
  ARTICLES = 'articles',
  MATCHES = 'matches',
  SQUADS = 'squads',
  PLAYERS = 'players',
  SQUAD_PLAYERS = 'squad-players',
  CLUBS = 'clubs',
  SPONSORS = 'sponsors',
  PAGE_TYPES = 'page-types',
  OTT_EVENTS = 'ott-events',
  OTT_FORMATS = 'ott-formats',
  OTT_PLAYLIST = 'ott-playlist',
  VENUES = 'venues',
}
